export const sanitize = (data: any) =>
	JSON.parse(
		JSON.stringify(data, (key, value) => (value === '' ? undefined : value)),
	);

export const sanitizeWithNull = (data: any) =>
	JSON.parse(
		JSON.stringify(data, (key, value) =>
			value === '' || value === null ? undefined : value,
		),
	);
